// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2QceP","loaderOuter":"PageOverlayLoader_loaderOuter__2ZuGN"};